import { useState, useEffect } from 'react'
import { decodeStorage } from 'functions/storageBase64'
import { requestPayment, requestPaymentSpei } from 'functions/requestPayment'
import { cybs_dfprofiler } from 'functions/deviceFingerprint'
import { updateCardT1 } from 'services/T1Pagos'
import { postPayPlanCards, postPayPlanSpei } from 'services/PagoTajetaSears'
import { MERCHANT_ID, STAGE_DIRNAME } from 'constants/general'
import { useToken } from 'hooks/useToken'

export function usePayCard(){

    const [ successPay, setSuccessPay ] = useState(null)
    const [ errorPay, setErrorPay ] = useState(null)
    const [ datosPago, setDatosPago ] = useState()
    const payCardRelation = decodeStorage('payCardRelation')
    let environment = ''

    const refreshCyR = useToken({firstActive: false, name: "payment"})

    if(STAGE_DIRNAME != 'dev'){
        environment = "live"
    }

    const [tokenJWT, setTokenJWT] = useState(false)
    const dataPayment = (value) => {
        setTokenJWT(value)
        //console.log("datos pago: ", value)
    }
    
    useEffect(()=>{
        if(tokenJWT){
            setDatosPago(tokenJWT)
            refreshCyR.forceToken(true)
            //console.log("datos pago: ", tokenJWT)
            setTokenJWT(false)
        }
    },[tokenJWT])
    
    // updateCard
    const [ responseT1, setResponseT1 ] = useState()
    useEffect(()=>{
        if(refreshCyR.newToken){
            if(datosPago){
                if(!datosPago.addCard){
                    //console.log('!datosPago.addCard: ',datosPago)
                    updateCardT1({dataRaw: {cvv2: datosPago?.cvv}, idCard: datosPago?.idCard })
                    .then(setResponseT1)
                }
                else{
                    //console.log('datosPago else: ',datosPago)
                    setResponseT1(datosPago?.addCard)
                    setDataCardT1(true)
                }
            }
        }
    },[refreshCyR.newToken])

    //- Trae datos de la tarjeta T1
    const [dataCardT1, setDataCardT1] = useState(false)
    const [dataSingleCard, setdataSingleCard] = useState()
    useEffect(()=>{
        //console.log("entro a responset1: ", responseT1?.statusCode)
        if(responseT1?.statusCode === 200){
            setdataSingleCard( requestPayment(responseT1?.data?.data, payCardRelation, cybs_dfprofiler(MERCHANT_ID, environment)) )
            setDataCardT1(true)
        }else if(responseT1?.statusCode === 401){
            setDataCardT1(false)
        }
        else if(responseT1?.statusCode === 429){
            setDataCardT1(false)
            setErrorPay(responseT1?.status?.error?.message)
        }
        else if(responseT1?.statusCode >= 404){
            setDataCardT1(false)
        }
        else if(responseT1?.statusCode >= 500){
            setDataCardT1(false)
            setErrorPay(500)
        }
    },[responseT1])
    
    //- Va al servicio de pago con los datos del plan
    const [responseServicePay, setResponseServicePay] = useState(false)
    useEffect(()=>{
        if(dataCardT1 && dataSingleCard){
            postPayPlanCards(dataSingleCard)
            .then(setResponseServicePay)
        }
    },[dataCardT1, dataSingleCard])
    
    
    // Regresa la respuesta si es success o error en el pago
    useEffect(()=>{
        if(responseServicePay){
            if(responseServicePay.statusCode === 200){               
                if(responseServicePay?.data?.data?.status === true){
                    setSuccessPay(responseServicePay?.data?.data?.authorization_id)
                }else if(responseServicePay?.data?.data?.status === false){
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }else{
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }
            }
            else if(responseServicePay.statusCode >= 400 && responseServicePay.statusCode <= 499){
                if(typeof(responseServicePay?.data) === 'string'){
                    let resp = JSON.parse(responseServicePay?.data)
                    setErrorPay({codMen: 31, message: resp?.data?.message})
                }else{
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }
            }
            else if(responseServicePay.statusCode >= 500){
                setErrorPay(500);
   
                // if(typeof(responseServicePay?.data) === 'string'){
                //     let resp = JSON.parse(responseServicePay?.data)
                    
                //     setErrorPay({codMen: 31, message: resp?.data?.message})
                // }else{
                //     setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                // }
            }
        }

    },[responseServicePay])


    return{
        successPay,
        errorPay,
        dataPayment
    }
}

export function usePaySpei(){

    const [ successPay, setSuccessPay ] = useState(null)
    const [ errorPay, setErrorPay ] = useState(null)
    const [ datosPago, setDatosPago ] = useState()
    const payCardRelation = decodeStorage('payCardRelation')

    const refreshCyR = useToken({firstActive: false, name: "paymentSpei"})

    const [tokenJWT, setTokenJWT] = useState(false)
    const dataPayment = (value) => {
        setTokenJWT(value)
        //console.log("datos pago: ", value)
    }
    
    useEffect(()=>{
        if(tokenJWT){
            setDatosPago(tokenJWT)
            refreshCyR.forceToken(true)
            //console.log("datos pago: ", tokenJWT)
            setTokenJWT(false)
        }
    },[tokenJWT])
    
    // updateCard
    const [dataCardT1, setDataCardT1] = useState(false)
    const [dataSingleCard, setdataSingleCard] = useState()
    useEffect(()=>{
        if(refreshCyR.newToken){
            if(datosPago){
                setdataSingleCard( requestPaymentSpei(datosPago?.userId, payCardRelation) )
                setDataCardT1(true)
            }else{
                setDataCardT1(false)
            }
        }
    },[refreshCyR.newToken])

    
    //- Va al servicio de pago con los datos del plan
    const [responseServicePay, setResponseServicePay] = useState(false)
    useEffect(()=>{
        if(dataCardT1 && dataSingleCard){
            // console.log('dataCardT1: ', dataCardT1)
            // console.log('dataSingleCard: ', dataSingleCard)
            postPayPlanSpei(dataSingleCard)
            .then(setResponseServicePay)
        }
    },[dataCardT1, dataSingleCard])
    
    
    // Regresa la respuesta si es success o error en el pago
    useEffect(()=>{
        if(responseServicePay){
            // console.log('responseServicePay: ', responseServicePay)
            if(responseServicePay.statusCode === 200){               
                if(responseServicePay?.data?.data?.account){
                    setSuccessPay({
                        //authorization_id: responseServicePay?.data?.data?.authorization_id,
                        spei_transfer: responseServicePay?.data?.data?.account
                    })

                }else if(responseServicePay?.data?.data?.status === false){
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }else{
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }
            }
            else if(responseServicePay.statusCode >= 400 && responseServicePay.statusCode <= 499){
                if(typeof(responseServicePay?.data) === 'string'){
                    let resp = JSON.parse(responseServicePay?.data)
                    setErrorPay({codMen: 31, message: resp?.data?.message})
                }else{
                    setErrorPay({codMen: 31, message: responseServicePay?.data?.data?.message})
                }
            }
            else if(responseServicePay.statusCode >= 500){
                setErrorPay(500);
            }
        }

    },[responseServicePay])

    return{
        successPay,
        errorPay,
        dataPayment
    }
}